const subjectRules = [
  {
    feedback: 'Subject is required',
    test(value) {
      return !!value;
    },
  },
  {
    feedback: 'Maximum length of 48 characters',
    test(value) {
      return value.length <= 48;
    },
  },
];

export default subjectRules;
